import { NgModule } from '@angular/core';
import { SharedModule } from '@shared';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ReusableModule } from '../reusable/reusable.module';
import { CommonModule } from '@angular/common';
import { PaymentsModule } from '../payments/paymentsmodule';
import { HospitalComponent } from './manage/hospital.component';
import { MY_DATE_FORMATS, MY_DATE_ADAPTER } from '../in-home-care/license-date-format';
import { HospitalRoutingModule } from './hospital-routing.module';
import { JsonArrayJoinPipe } from '@shared/pipes/json-array-join.pipe';
import { OnCampusBuildingComponent } from './on-campus-building/on-campus-building.component';
import { SatelliteLocationComponent } from './satellite-location/satellite-location.component';
import { HospitalClaimsComponent } from './hospital-claims/hospital-claims.component';
import { HospitalAssignedComponent } from './hospital-assigned/hospital-assigned.component';
import { HospitalContactsExportComponent } from './hospital-contacts-export/hospital-contacts-export.component';
import { HospitalManagementComponent } from './hospital-management/hospital-management.component';
import { HospitalServiceLocationComponent } from './hospital-service-location/hospital-service-location.component';

const COMPONENTS = [
  HospitalComponent,
  OnCampusBuildingComponent,
  SatelliteLocationComponent,
  HospitalClaimsComponent,
  HospitalAssignedComponent,
  HospitalContactsExportComponent,
  HospitalManagementComponent,
  HospitalServiceLocationComponent
]

const PIPES = [
  JsonArrayJoinPipe
]


@NgModule({
  declarations: [...COMPONENTS, ...PIPES],
  imports: [
    CommonModule,
    SharedModule,
    ReusableModule,
    HospitalRoutingModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PaymentsModule,

  ],
  exports: [...PIPES],
  providers: [
    provideNgxMask(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MY_DATE_FORMATS,
    MY_DATE_ADAPTER,
  ]
})
export class HospitalModule { }
